module.exports = "/_next/static/files/305969bc1ac8fbd4543941a9b6be088e.svg";